import { render, staticRenderFns } from "./PartnerFaqList.vue?vue&type=template&id=2f8025fc&"
import script from "./PartnerFaqList.vue?vue&type=script&lang=ts&"
export * from "./PartnerFaqList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports